import { render, staticRenderFns } from "./BankHistory.vue?vue&type=template&id=7a7d684f"
import script from "./BankHistory.vue?vue&type=script&lang=js"
export * from "./BankHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports